(function(angular){
    'use strict';

    angular.module('onvio.setup.client.notifications').directive('clientNotificationWording',
        [
            function(){
                return {
                    restrict: 'E',
                    replace: true,
                    scope: {
                        categories: '=',
                        language: '='
                    },
                    templateUrl: 'setup/src/client-notifications/wording/wording.html',
                    controller: 'onvio.setup.client.notifications.WordingController',
                    controllerAs: 'vm',
                    bindToController: true
                };
            }
        ]
    );
})(window.angular);
